import { render, staticRenderFns } from "./SocleNotificationPage.vue?vue&type=template&id=ff146842&"
import script from "./SocleNotificationPage.vue?vue&type=script&lang=ts&"
export * from "./SocleNotificationPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports